module.exports = __webpack_public_path__ + "static/joyful_3-1425aab2bc8f58ea2c29cb6804cc47be.jpg";